// src/store/authSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserInfo {
  email?: string;
  name?: string;
  socketStatus: string;
  _id?: string;
  profilePic?: string;
  unreadGroupMessages?: {
    [key: string]: number;
  };
  unreadPrivateMessages?: {
    [key: string]: number;
  };
}

interface AuthState {
  userId: any;
  currentUser: any;
  token: string | null;
  userInfo?: any;
  role: any
}

const initialState: AuthState = {
  token: null,
  userInfo: null,
  userId: undefined,
  currentUser: undefined,
  role: undefined
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string | null>) => {
      // eslint-disable-next-line no-param-reassign
      state.token = action.payload;
    },
    clearToken: (state) => {
      // eslint-disable-next-line no-param-reassign
      state.token = null;
    },
   
    setUserInfo: (state, action: PayloadAction<UserInfo>) => {
      // eslint-disable-next-line no-param-reassign
      state.userInfo = action.payload;
    },
    updateSocketStatus: (state, action: PayloadAction<string>) => {
      // eslint-disable-next-line no-param-reassign
      state.userInfo.socketStatus = action.payload;
    },
    updateUserNotifications: (state, action: PayloadAction<any>) => {
      const {
        unreadGroupMessages,
        unreadPrivateMessages,
        privateConversationId,
        chatRoomId,
      } = action.payload;
      if (unreadGroupMessages && unreadGroupMessages) {
        state.userInfo.unreadGroupMessages = unreadGroupMessages;
        state.userInfo.unreadPrivateMessages = unreadPrivateMessages;
      } else if (privateConversationId) {
        state.userInfo.unreadPrivateMessages = {
          ...state.userInfo.unreadPrivateMessages,
          [privateConversationId]:
            (state.userInfo.unreadPrivateMessages[privateConversationId] || 0)
            + 1,
        };
      } else {
        state.userInfo.unreadGroupMessages = {
          ...state.userInfo.unreadGroupMessages,
          [chatRoomId]:
            (state.userInfo.unreadGroupMessages[chatRoomId] || 0) + 1,
        };
      }
    },
    clearUserInfo: (state) => {
      // eslint-disable-next-line no-param-reassign
      state.userInfo = null;
    },
  },
});

export const {
  setToken,
  clearToken,
  setUserInfo,
  clearUserInfo,
  updateUserNotifications,
  updateSocketStatus,
} = authSlice.actions;
const authReducer = authSlice.reducer;
export const currentUser = (state: any) => state.auth.userInfo;
export const privateMessagesUpdate = (state: any) => state.auth.userInfo.unreadPrivateMessages;
export const unreadGroupMessagesUpdate = (state: any) => state.auth.userInfo.unreadGroupMessages;
export default authReducer;
